import React from 'react';
import '../styles/Header.css';
import SearchIcon from '@material-ui/icons/Search';
import HeaderOption from './HeaderOption';
import HomeIcon from '@material-ui/icons/Home';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import ChatIcon from '@material-ui/icons/Chat';
import NotificationsIcon from '@material-ui/icons/Notifications';
import linkedinLogo from '../photos/linkedinlogo.png';
import {logout } from '../features/UserSlice';
import { useDispatch } from 'react-redux';
import { auth } from '../firebase';

function Header(props) {

    const dispatch = useDispatch();

    const logoutOfApp= () =>{
        //should dispatch action logout
        dispatch(logout())
        auth.signOut()
    }
    return (
        <div className='linkedin-header'>
            <div className="linkedin_header_left">
                <img src={linkedinLogo} 
                alt="Unable to load logo">
                </img>
                <div className="header_search">
                    <SearchIcon/>
                    <input type="text"/>
                </div>
            </div>

            <div className="linkedin_header_right">
                <HeaderOption  title='Home' Icon={HomeIcon}/>
                <HeaderOption title='My Network'Icon={SupervisorAccountIcon}/>
                <HeaderOption title='jobs' Icon={BusinessCenterIcon}/>
                <HeaderOption title='Messaging' Icon={ChatIcon}/>
                <HeaderOption title='Notifications' Icon={NotificationsIcon}/>
                <HeaderOption  title="me" shouldShowAvatar={true}
                onClick={logoutOfApp}
               />
            </div>
        </div>
    );
}

export default Header;